import { render, staticRenderFns } from "./productJiwa.vue?vue&type=template&id=367e7e7a&"
import script from "./productJiwa.vue?vue&type=script&lang=ts&"
export * from "./productJiwa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports